import {
  Text,
  type TextColor,
  type TextWeight,
  TextWeightValue,
  theme,
} from '@/components';
import { useColor } from '@/hooks';
import { ExportOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import type { FC, MouseEvent, ReactNode } from 'react';
const { Link: AntdLink } = Typography;

type Props = (
  | {
      href: string;
    }
  | {
      onClick: (e?: MouseEvent<HTMLElement, globalThis.MouseEvent>) => void;
    }
  | {
      noInteraction: true;
    }
) & {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  fontWeight?: TextWeight;
  color?: TextColor;
  isEllipsis?: boolean;
  showIcon?: boolean;
  customIcon?: ReactNode;
};
export const LinkText: FC<Props> = (props) => {
  const { token } = theme.useToken();
  const { getColorValue } = useColor();

  const size = props.size ?? 'md';
  const fontWeight = props.fontWeight ?? 'regular';
  const showIcon = props.showIcon ?? 'href' in props;

  return !props.text ? (
    <Text
      variant={size === 'sm' ? 'footnote' : 'body'}
      text={props.text}
      ellipsis={props.isEllipsis}
    />
  ) : (
    <AntdLink
      href={'href' in props ? props.href : undefined}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        fontSize: {
          sm: token.fontSizeSM,
          md: token.fontSize,
          lg: token.fontSizeLG,
        }[size],
        fontWeight: TextWeightValue[fontWeight],
        ...(props.color && { color: getColorValue(props.color) }),
        ...(props.isEllipsis && {
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }),
      }}
      onClick={(e) => ('onClick' in props ? props.onClick(e) : undefined)}
      data-umami-event={props.text}
      data-dd-privacy="allow"
    >
      {props.text}
      {showIcon &&
        (props.customIcon ? (
          props.customIcon
        ) : (
          <span style={{ marginLeft: 4 }}>
            <ExportOutlined />
          </span>
        ))}
    </AntdLink>
  );
};
